export const areFrequenciesEqual = (a, b) => a.intervalCount === b.intervalCount && a.interval === b.interval;

